import React from 'react'
import { PAGEBREAK_CLASSNAME } from './report-styles'

export function PageBreak(): React.ReactElement {
  return <div className={PAGEBREAK_CLASSNAME} />
}
